<template>
  <div>
    <div class="grid-content container">
      <!-- top标题状态栏-->
      <div class="float-layout overlay">
        <a-row type="flex" justify="space-around" align="middle">
          <a-col class="w17-pc"> <!--:span="4"-->
            <span>供应商当天负荷</span>
          </a-col>
          <a-col class="w10-pc">
            <span>排产日期日期范围</span>
          </a-col>
          <a-col class="w20-pc">
            <a-range-picker v-model="queryParams.dateRange" @change="onDateRangeChange" />
          </a-col>
          <a-col class="w7-pc">
            <span class="pl28">供应商</span>
          </a-col>
          <a-col class="w46-pc">
            <global-select
              v-model="queryParams.vendorCode"
              v-decorator="[
                'vendorCode',
                { rules: [{ required: true, message: '请选择供应商' }] }
              ]"
              @change="handleVendorChange"
              requestApi="/scp/scpProductionScheduling/listPcSupplier"
              :selectItem="{ value: 'realValue', label: 'label' }"
            />
          </a-col>
        </a-row>
      </div>
      <div class="content" id="ipage-chart-send" ref="send"></div>
    </div>
  </div>
</template>
<script>
import * as echarts from 'echarts';
import { operationCnSearch } from "@/api/scp/productionScheduling/schedulingWorkbench.js"
import moment from 'moment'
export default {
	name: 'SupplierDailyChart',
	components: {
	},
	mounted () {
    this.renderChart({
      xAxis: {
        type: 'category',
        data: []
      },
      grid: {
        top: '15%',
        left: '2%',
        right: '2%',
        bottom: '5%',
        containLabel: true
      },
      yAxis: {
        type: 'value'
      },
      series: [
        {
        data: [],
        type: 'line'
        }
      ]
    })
	},
  data () {
    return {
      queryParams: {
        vendorCode: '',
        startDate: '',
        endDate: '',
        dateRange: []
      }
    }
  },
	methods: {
    setQueryParamsAndQuery (vendorCode, startDate, endDate) {
      this.queryParams.startDate = startDate
      this.queryParams.endDate = endDate
      this.queryParams.dateRange = [ moment(startDate), moment(endDate) ]
      if (vendorCode) {
        this.queryParams.vendorCode = vendorCode
        this.initData()
      }
    },
    renderChart (option) {
      console.log(option)
      const myChart = echarts.init(this.$refs.send);
      option && myChart.setOption(option, true);
    },
    initData () {
      operationCnSearch({
        vendorCode: this.queryParams.vendorCode,
        startDate: this.queryParams.startDate,
        endDate: this.queryParams.endDate
      }).then(res => {
        console.log(res)
        // 首先，按日期排序
        res.sort((a, b) => a.startDate.localeCompare(b.startDate));

        // 然后，根据 operationDesc 分组数据
        const groupedData = res.reduce((result, item) => {
          const operationDesc = item.operationDesc;
          const existingEntry = result.find(entry => entry.name === operationDesc);

          if (existingEntry) {
            existingEntry.data.push(item.procedureLoad * 100);
          } else {
            result.push({ name: operationDesc, data: [item.procedureLoad * 100], type: 'line' });
          }

          return result;
        }, []);
        const uniqueStartDates = [...new Set(res.map(item => item.startDate))];
        const uniqueLineCodes = [...new Set(res.map(item => item.operationDesc))];

        console.log(groupedData);

        this.renderChart({
          xAxis: {
            type: 'category',
            data: uniqueStartDates
          },
          legend: {
            x: 'right',
            y: 'top',
            data: uniqueLineCodes
          },
          grid: {
						left: '2%',
						right: '2%',
						bottom: '5%',
						containLabel: true
					},
          tooltip: {
						trigger: 'axis',
            valueFormatter: (value) => `${parseFloat(value.toFixed(4))}%`
					},
          yAxis: {
            type: 'value'
          },
          series: groupedData
        })
      })
    },
    onDateRangeChange (val) {
      this.queryParams.startDate = val[0].format('YYYY-MM-DD')
      this.queryParams.endDate = val[1].format('YYYY-MM-DD')
      if (this.queryParams.vendorCode) {
        this.initData()
      }
    },
    handleVendorChange (val) {
      this.queryParams.vendorCode = val
      if (this.queryParams.startDate && this.queryParams.endDate) {
         this.initData()
      }
    }
  }
}
</script>
<style lang="less" scoped>
.grid-content {
    width: 100%;
	border-radius: 4px;
	min-height: 36px;
	background: rgb(255, 255, 255);
}
.float-layout {
    z-index: 2;
}
.container {
  position: relative;
//   width: 300px;
//   height: 200px;
  // height: 200px;
  width: 100%;
}

.overlay {
  // position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  // height: 100%;
  z-index: 2; /* 设置较高的 z-index 值 */
}

.content {
  position: relative;
  z-index: 1; /* 设置较低的 z-index 值 */
  height: 250px;
  // width: 1000px
}
.w12-pc {
	width: 12%;
}
.w7-pc {
	width: 7%;
}
.w10-pc {
  width: 10%;
}
.w20-pc {
  width: 20%;
}
.w46-pc {
  width: 46%;
}
.pl28 {
  padding-left: 28px;
}
.w17-pc {
  width: 17%;
}
</style>
